<template>
	<div class="auth-sidebar">
		<BaseAuthUser v-slot="{isLoggedIn, urls, user, currentUrl}">
			<template v-if="isLoggedIn">
				<div class="auth-sidebar-title"><BaseCmsLabel tag="span" code="hello" /> {{ user?.first_name }}</div>
				<ul class="auth-menu">
					<li>
						<NuxtLink :to="urls.auth" :class="['am-user', {'active': urls.auth == currentUrl}]"><BaseCmsLabel tag="span" code="my_profile" /></NuxtLink>
					</li>
					<li>
						<NuxtLink :to="urls.auth_my_webshoporder" :class="['am-orders', {'active': urls.auth_my_webshoporder == currentUrl}]"><BaseCmsLabel tag="span" code="my_orders" /></NuxtLink>
					</li>
					<li>
						<NuxtLink :to="urls.auth_my_webshopcoupon" :class="['am-coupon', {'active': urls.auth_my_webshopcoupon == currentUrl}]"><BaseCmsLabel tag="span" code="my_coupons" /></NuxtLink>
					</li>
					<li>
						<NuxtLink :to="urls.auth_my_comment" :class="['am-comment', {'active': urls.auth_my_comment == currentUrl}]"><BaseCmsLabel tag="span" code="my_webshop_comment" /></NuxtLink>
					</li>
					<li>
						<NuxtLink :to="urls.auth_edit" :class="['am-edit', {'active': urls.auth_edit == currentUrl}]"><BaseCmsLabel tag="span" code="edit_profile" /></NuxtLink>
					</li>
					<li>
						<NuxtLink :to="urls.auth_change_password" :class="['am-password', {'active': urls.auth_change_password == currentUrl}]"><BaseCmsLabel tag="span" code="change_password" /></NuxtLink>
					</li>
					<li>
						<NuxtLink :to="urls.auth_logout" class="am-logout"><BaseCmsLabel code="logout" tag="span" /></NuxtLink>
					</li>
				</ul>

				<div v-if="user?.loyalty_code" class="auth-box-loyalty" :style="labelImage?.length ? { background: `url(${labelImage[0].url})` } : {}">
					<BaseCmsLabel code="auth_loyalty_sidebar_title" tag="div" class="auth-title-loyalty" />
					<div class="auth-loyalty-cnt">
						<BaseCmsLabel code="card_number" tag="span" class="label" /><span class="value">{{ user?.loyalty_code }}</span>
					</div>
					<div class="auth-loyalty-cnt">
						<BaseCmsLabel code="full_name" tag="span" class="label" /><span class="value">{{ user?.first_name }} {{ user?.last_name }}</span>
					</div>
				</div>				
			</template>
		</BaseAuthUser>
	</div>
</template>

<script setup>
	const labels = useLabels();
	const {onMediaQuery, appendTo} = useDom();

	//rwd
	const {mobileBreakpoint} = inject('rwd');

	const { extractImageUrls } = useImages();
	const labelImage = extractImageUrls(labels.get('dashboard_loyalty_sidebar_background'));

	onMediaQuery({
		query: '(max-width: 1100px)',
		enter: () => {
			appendTo('.auth-box-loyalty', '.auth-wrapper');
		},
		leave: () => {
			appendTo('.auth-box-loyalty', '.auth-sidebar');
		}
	});
</script>

<style scoped lang="less">
	.auth-sidebar-title{
		font-size: clamp(18px, 3vw, 12px); font-weight: bold; padding: 0 0 16px; line-height: 1.4;
		span{font-size: 16px; display: block; font-weight: normal;}
	}
	.auth-sidebar{
		width: 25%; flex-grow: 0; flex-shrink: 0;
		@media (max-width: @t){width: 100%;}
	}
	.auth-menu{
		list-style: none; margin-bottom: 24px;
		@media (max-width: @t){
			display: flex; flex-wrap: wrap; gap: 10px; position: relative; padding-bottom: 30px;
			&:after{.pseudo(auto, 1px); left: -15px; right: -15px; bottom: 0; background: var(--gray4);}
		}
		li{
			margin: 0 0 10px;
			@media (max-width: @t){width: calc(~"50% - 5px"); margin: 0;}
			a{
				display: flex; align-items: center;  min-height: 42px; padding: 0 20px; background: #fff; border: 1px solid var(--blueDark); border-radius: 8px; font-size: 15px; line-height: 1.35; text-decoration: none; color: var(--blueDark); .transition(all);
				&.active{background: var(--blueDark); color: #fff;}
				@media (min-width: @t){
					&:hover{background: var(--blueDark); color: #fff;}
				}
				@media (max-width: @m){
					margin-right: 8px; font-size: 14px; white-space: nowrap;
					&:last-child{margin-right: 0;}
				}
			}
		}
	}
	.auth-box-loyalty{
		border-radius: 12px; padding: 24px; color: #fff; background-size: cover; background-repeat: no-repeat; background-position: center right;
		@media (max-width: @t){margin: 25px -15px -20px; border-radius: 0; padding: 15px; display: none;}
	}
	.page-dashboard .auth-box-loyalty{display: block;}
	.auth-title-loyalty{font-weight: bold; padding-bottom: 10px; font-size: 20px;}
	.auth-loyalty-cnt{
		padding: 10px 0 0;
		.label{display: block; font-weight: bold;}
	}
</style>